<div class="cmps-cdk-d-flex cmps-cdk-h-100p cmps-cdk-align-items-center">
    <div
        *ngFor="let kpi of kpis"
        class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-w-100pct cmps-cdk-h-100p cmps-cdk-justify-content-center cmps-cdk-align-items-center cmps-cdk-px-1 cmps-cdk-cursor-pointer hover:cmps-cdk-bg-color-grey-500"
        [class.cmps-coaching-navigation-bar--selected]="kpi === selectedKpi"
        [class.cmps-cdk-bg-color-grey-500]="kpi === selectedKpi"
        [style.border-bottom-color]="kpi.kpiColour"
        [cmpsTooltipTrigger]="insightProgressBarTooltip"
        [cmpsTooltipTriggerCustomTemplate]="true"
        placement="bottom-center"
        role="button"
        tabindex="-1"
        (click)="_onSelectClick(kpi)"
    >
        <div
            class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-font-size-14p cmps-cdk-font-bold"
        >
            <div>
                {{ kpi.kpiName }}
            </div>
            <div
                class="cmps-cdk-min-w-20px cmps-cdk-min-h-20p cmps-cdk-border-radius-4px cmps-cdk-mx-0dot5 cmps-cdk-my-0dot25"
                [style.background]="kpi.kpiColour | cmpsBgGradient"
            ></div>
            <div>
                {{ kpi.kpiValue / 100 | cmpsPercent: '1.0-0' }}
            </div>
        </div>
        <div
            class="cmps-coaching-navigation-bar--progress-bar cmps-cdk-w-100pct cmps-cdk-border-radius-6p cmps-cdk-bg-color-grey-300 cmps-cdk-mx-0dot5 cmps-cdk-overflow-hidden"
        >
            <div
                class="cmps-cdk-border-radius-6p cmps-cdk-h-100p"
                [style.background]="kpi.kpiColour | cmpsBgGradient"
                [style.width.%]="kpi.kpiValue"
            ></div>
        </div>
        <ng-template #insightProgressBarTooltip>
            <cmps-dialog>
                <cmps-dialog-body
                    class="cmps-cdk-m-0dot5 cmps-coaching-navigation-bar--tooltip"
                >
                    <div
                        class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-align-items-flex-start"
                    >
                        <div class="cmps-cdk-font-size-14p cmps-cdk-font-bold">
                            {{ kpi.kpiName }}
                        </div>
                        <div class="cmps-cdk-d-flex cmps-cdk-mt-0dot5">
                            <div class="cmps-cdk-mr-0dot5 cmps-cdk-font-bold">
                                {{ _i18n._773_PERIOD | translate }}:
                            </div>
                            <div>
                                {{
                                    selectedPeriodType.startDate
                                        | cmpsDate: 'MMM-d-y'
                                }}
                                &nbsp;-&nbsp;
                                {{
                                    selectedPeriodType.endDate
                                        | cmpsDate: 'MMM-d-y'
                                }}
                            </div>
                        </div>
                        <div
                            class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-mt-0dot5"
                        >
                            <div class="cmps-cdk-mr-0dot5 cmps-cdk-font-bold">
                                {{ _i18n._725_ACTUAL | translate }}:
                            </div>
                            <div
                                class="cmps-cdk-min-w-12px cmps-cdk-min-h-12p cmps-cdk-border-radius-4px cmps-cdk-mr-0dot5"
                                [style.background]="
                                    kpi.kpiColour | cmpsBgGradient
                                "
                            ></div>
                            <!-- Todo: use cmpsWpNumber pipe instead, once PR is approved -->
                            <div>
                                {{
                                    kpi.actual == null
                                        ? '-'
                                        : (kpi.actual | cmpsNumber: '1.1-1')
                                }}
                            </div>
                        </div>
                        <div
                            class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-mt-0dot5"
                        >
                            <cmps-icon
                                svgIcon="target"
                                class="cmps-cdk-d-flex cmps-cdk-pr-0dot5"
                            ></cmps-icon>
                            <div class="cmps-cdk-mr-0dot5 cmps-cdk-font-bold">
                                {{ _i18n._726_TARGET | translate }}:
                            </div>
                            <!-- Todo: use cmpsWpNumber pipe instead, once PR is approved -->
                            <div>
                                {{
                                    kpi.target == null
                                        ? '-'
                                        : (kpi.target | cmpsNumber: '1.1-1')
                                }}
                            </div>
                        </div>
                        <div
                            class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-mt-0dot5"
                        >
                            <div class="cmps-cdk-mr-0dot5 cmps-cdk-font-bold">
                                {{ _i18n._768__TO_TARGET | translate }}:
                            </div>
                            <div
                                class="cmps-cdk-min-w-12px cmps-cdk-min-h-12p cmps-cdk-border-radius-4px cmps-cdk-mr-0dot5"
                                [style.background]="
                                    kpi.kpiColour | cmpsBgGradient
                                "
                            ></div>
                            <!-- Todo: use cmpsWpPercent pipe (move to central usage location???) -->
                            <div>
                                {{
                                    kpi.percentToTarget == null
                                        ? '-'
                                        : (kpi.percentToTarget
                                          | cmpsPercent: '1.1-1')
                                }}
                            </div>
                        </div>
                    </div>
                </cmps-dialog-body>
            </cmps-dialog>
        </ng-template>
    </div>
</div>
